/* ==========================================================================
   OSERE — WhatsApp flotante

   Estaba incrustado en la sección. Vive en el grupo del pie, así que viajaba
   en el HTML de LAS OCHO PÁGINAS y se re-parseaba en cada carga sin poder
   cachearse. Aquí es un archivo y el navegador lo guarda una vez.

   Lo único que dependía de Liquid era `section.id`, para encontrar su raíz por
   `getElementById`. Ahora se busca por `[data-os-wa]`, que además admite más
   de una instancia sin tocar nada. La clave de `sessionStorage` sale del mismo
   atributo, así que sigue siendo única por sección.
   ========================================================================== */

(function () {
  'use strict';

  function montar(ambito) {
      var raiz = ambito.querySelector('[data-os-wa]');
      if (!raiz) return;

      var globo = raiz.querySelector('[data-globo]');
      var clave = 'os-wa-cerrado-' + (raiz.getAttribute('data-os-wa') || '1');

      function abrirGlobo() {
        if (!globo) return;
        /* sessionStorage puede lanzar en modo privado o con cookies bloqueadas.
           Si lanza, el globo se enseña: fallar hacia enseñarlo es lo correcto,
           porque lo que se pierde es recordar que ya lo cerraron. */
        try {
          if (sessionStorage.getItem(clave) === '1') return;
        } catch (e) {}
        globo.hidden = false;
        /* Doble rAF: el navegador tiene que pintar el estado inicial ANTES de
           que llegue la clase, o la transición no ocurre y aparece de golpe. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            globo.classList.add('os-wa-visible');
          });
        });
      }

      if (globo) {
        var d = raiz.dataset.disparador;
        if (d === 'espera') {
          setTimeout(abrirGlobo, (parseInt(raiz.dataset.espera, 10) || 6) * 1000);
        } else if (d === 'scroll') {
          var alBajar = function () {
            if (window.scrollY > window.innerHeight * 0.4) {
              abrirGlobo();
              window.removeEventListener('scroll', alBajar);
            }
          };
          window.addEventListener('scroll', alBajar, { passive: true });
          alBajar();
        } else {
          abrirGlobo();
        }

        var cerrar = raiz.querySelector('[data-cerrar]');
        if (cerrar) {
          cerrar.addEventListener('click', function () {
            globo.classList.remove('os-wa-visible');
            setTimeout(function () {
              globo.hidden = true;
            }, 400);
            try {
              sessionStorage.setItem(clave, '1');
            } catch (e) {}
          });
        }
      }

      if (raiz.dataset.ocultar === 'true') {
        var ultimo = window.scrollY;
        var pendiente = 0;
        window.addEventListener(
          'scroll',
          function () {
            if (pendiente) return;
            pendiente = setTimeout(function () {
              pendiente = 0;
              var y = window.scrollY;
              /* Solo se esconde BAJANDO y lejos del inicio: ocultarlo al primer
                 scroll lo haría parpadear en cada microgesto. */
              raiz.classList.toggle('os-wa-oculto', y > ultimo && y > 300);
              ultimo = y;
            }, 120);
          },
          { passive: true }
        );
      }
  }

  function init(a) { montar(a || document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
